<span class="badge__wrapper">
    <ng-content></ng-content>
</span>
